module.exports = __webpack_public_path__ + "img/e_3_20_g.61013d5e.png";